// Trial Balance Vuex

import state from './trialBalanceStates.js'
import * as getters from './trialBalanceGetters.js'
import * as mutations from './trialBalanceMutations.js'
import * as actions from './trialBalanceActions.js'

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
